// assets/nd-export-image.js — 共用圖片工具（PDF / XLSX）— DOM 優先 + Pattern/need_drawing 優先
(function () {
  if (window.__ND_EXPORT_IMAGE_HELPERS__) return;
  window.__ND_EXPORT_IMAGE_HELPERS__ = true;

  function shopifyFileUrl(basename) {
    if (!basename) return null;
    if (/^https?:\/\//i.test(basename)) return basename;
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    return [`${root}files/${basename}.webp`, `${root}files/${basename}.png`, `${root}files/${basename}.jpg`];
  }

  function domImgsFromRow(rowEl) {
    const out = [];
    if (!rowEl) return out;
    rowEl.querySelectorAll('img[src]').forEach(img => { if (img.src) out.push(img.src); });
    rowEl.querySelectorAll('img[data-src],img[data-image],img[data-srcset]').forEach(img => {
      const u = img.getAttribute('data-src') || img.getAttribute('data-image') || '';
      if (u) out.push(u);
      const ss = img.getAttribute('data-srcset') || '';
      const pick = (ss.split(',')[0] || '').trim().split(' ')[0];
      if (pick) out.push(pick);
    });
    rowEl.querySelectorAll('img[srcset]').forEach(img => {
      const ss = img.getAttribute('srcset') || '';
      const pick = (ss.split(',')[0] || '').trim().split(' ')[0];
      if (pick) out.push(pick);
    });
    return out.filter(u => u && !/^data:/i.test(u));
  }

  function normalizeWxH(gridText) {
    const nums = String(gridText || '').match(/\d+/g);
    return (nums && nums.length >= 2) ? `${nums[0]}x${nums[1]}` : '';
  }

  function gridFallbacksFromPairs(pairs) {
    const dict = {};
    (pairs || []).forEach(([k, v]) => { if (k) dict[String(k).trim()] = String(v || '').trim(); });
    const grid  = dict['Grid Pattern'] || '';
    const style = dict['Grid Pattern Style'] || '';
    const files = [];
    const wxh = normalizeWxH(grid) || '2x3';
    if (/Equal\s*Lite/i.test(style))       files.push(shopifyFileUrl(`${wxh}_equal_lite`));
    if (/4\s*Lite\s*Tall/i.test(style))    files.push(shopifyFileUrl(`${wxh}_4_lite_tall`));
    if (/9\s*Lite\s*Prairie/i.test(style)) files.push(shopifyFileUrl(`${wxh}_9_lite_prairie`));
    if (/Special\s*Pattern/i.test(style))  files.push(shopifyFileUrl(`need_drawing`));
    return (files.flat ? files.flat() : files).filter(Boolean);
  }

  async function fetchAsBlob(url) {
    const final = /\/files\//.test(url) ? url : (url + (url.includes('?') ? '&' : '?') + 'width=420');
    const r = await fetch(final, { mode: 'cors', credentials: 'omit', cache: 'no-store' });
    if (!r.ok) throw new Error('image fetch failed: ' + r.status);
    return await r.blob();
  }

  function blobToCanvas(blob, targetW = 420) {
    return new Promise((resolve, reject) => {
      const u = URL.createObjectURL(blob);
      const img = new Image(); img.crossOrigin = 'anonymous';
      img.onload = () => {
        const scale = Math.min(targetW, img.width) / Math.max(1, img.width);
        const w = Math.max(10, Math.round(img.width * scale));
        const h = Math.max(10, Math.round(img.height * scale));
        const c = document.createElement('canvas'); c.width = w; c.height = h;
        c.getContext('2d').drawImage(img, 0, 0, w, h);
        URL.revokeObjectURL(u);
        resolve(c);
      };
      img.onerror = (e) => { URL.revokeObjectURL(u); reject(e); };
      img.src = u;
    });
  }

  const _cacheDataUrl = new Map();
  async function urlListToDataUrl(urlOrList, targetW = 360) {
    const list = Array.isArray(urlOrList) ? urlOrList : [urlOrList];
    for (const u of list) {
      if (!u) continue;
      if (_cacheDataUrl.has(u)) return _cacheDataUrl.get(u);
      try {
        const blob = await fetchAsBlob(u);
        const canvas = await blobToCanvas(blob, targetW);
        const dataUrl = canvas.toDataURL('image/png', 0.92);
        _cacheDataUrl.set(u, dataUrl);
        return dataUrl;
      } catch (_) { /* try next */ }
    }
    return null;
  }

  const _cacheB64 = new Map();
  async function urlToBase64PNG(urlOrList, targetW = 420) {
    const list = Array.isArray(urlOrList) ? urlOrList : [urlOrList];
    for (const u of list) {
      if (!u) continue;
      if (_cacheB64.has(u)) return _cacheB64.get(u);
      try {
        const blob = await fetchAsBlob(u);
        const canvas = await blobToCanvas(blob, targetW);
        const dataUrl = canvas.toDataURL('image/png', 0.92);
        const base64 = dataUrl.split(',')[1] || '';
        if (base64) { _cacheB64.set(u, base64); return base64; }
      } catch (_) { /* try next */ }
    }
    return null;
  }

  // === 核心：統一取圖（Pattern/need_drawing 優先，其次 DOM 圖，最後商品圖） ===
  function getItemImageUrls(lineItem, domPairsOptional, lineItemRow) {
    const listA = gridFallbacksFromPairs(domPairsOptional);   // Pattern / need_drawing
    const listB = domImgsFromRow(lineItemRow);
    const listC = [];
    if (lineItem?.image || lineItem?.featured_image) {
      listC.push(lineItem.image || lineItem.featured_image.url || lineItem.featured_image.src);
    }
    // 重新排序：need_drawing/ pattern 關鍵字優先
    const arr = [...listA, ...listB, ...listC].filter(Boolean);
    const key = /(need_drawing|_equal_lite|_4_lite_tall|_9_lite_prairie)/i;
    arr.sort((u, v) => (key.test(v) ? 1 : 0) - (key.test(u) ? 1 : 0));
    return Array.from(new Set(arr));
  }
  async function getItemImageUrl(lineItem, domPairsOptional, lineItemRow) {
    const list = getItemImageUrls(lineItem, domPairsOptional, lineItemRow);
    return Array.isArray(list) ? list[0] : list;
  }

  window.shopifyFileUrl   = window.shopifyFileUrl   || shopifyFileUrl;
  window.getItemImageUrls = window.getItemImageUrls || getItemImageUrls;
  window.getItemImageUrl  = window.getItemImageUrl  || getItemImageUrl;
  window.urlListToDataUrl = window.urlListToDataUrl || urlListToDataUrl;
  window.urlToBase64PNG   = window.urlToBase64PNG   || urlToBase64PNG;

  window.NDIMG = Object.freeze({ shopifyFileUrl, getItemImageUrls, getItemImageUrl, urlListToDataUrl, urlToBase64PNG });
})();
